import { jsx as _jsx } from "react/jsx-runtime";
import { TextareaInput } from "./styled";
export const Textarea = ({ onChange, ...props }) => {
    return (_jsx(TextareaInput, { onChange: ((e) => {
            const currentValue = e.target.value;
            onChange?.(currentValue);
        }), ...props }));
};
